



















import { Component, Vue } from "vue-property-decorator";

import { languages } from "./";

@Component
export default class LanguageMenu extends Vue {
  isActive = false;
  languages = languages;

  setLanguage(locale: string) {
    this.isActive = false;
    this.$i18n.i18next.changeLanguage(locale);
  }
}
